import { fetchClient } from '../../Utils/helpers';
import { CREATE_SUBSCRIPTION, GET_SUBSCRIPTIONS, UPDATE_SUBSCRIPTIONS } from '../actionTypes';

export function createSubscription(subsId, userId) {
  return {
    type: CREATE_SUBSCRIPTION,
    payload: fetchClient({
      method: 'POST',
      url: `/user/subscription/${userId}/session`,
      data: {
        product_id: subsId,
      },
    }).then((res) => {
      window.location.href = res.data.data.url;
      return res;
    }),
  };
}

export const getSubscriptions = () => (
  {
    type: GET_SUBSCRIPTIONS,
    payload: fetchClient({
      method: 'GET',
      url: '/admin/subscriptions',
    }),
  }
);

export const updateSubscriptions = (data) => (
  {
    type: UPDATE_SUBSCRIPTIONS,
    payload: fetchClient({
      method: 'POST',
      url: '/admin/subscriptions',
      data,
    }),
  }
);
